
class CheckoutSteps {
  constructor() {
    this.isInitialized = false;
    this.stepsContainer = jQuery('.mad-checkout-steps');
    this.steps = [];

    // Reference to buttons
    this.nextButton = jQuery('.mad-checkout-steps__button.next');
    this.prevButton = jQuery('.mad-checkout-steps__button.previous');
    this.finalButton = jQuery('.mad-checkout-steps__button.final');
    this.finalButtonContainer = jQuery('.mad-checkout-steps__button.final').parent();

    this.initSteps();
    this.isInitialized = true;

    jQuery(document.body).trigger('madCheckoutStepsInitialized');
  }


  initSteps() {
    if (this.stepsContainer.length === 0) return;

    var stepIndexToActivate = 0;

    const stepElements = this.stepsContainer.children('.mad-checkout-steps__step');
    stepElements.each((index, element) => {
      const stepElement = jQuery(element);
      const step = new CheckoutStep({
        number: parseInt(stepElement.attr('data-step-number'), 10),
        index: parseInt(stepElement.attr('data-step-index'), 10),
        id: stepElement.attr('data-step-id'),
        container: stepElement,
        icon: stepElement.children('.mad-checkout-steps__step--icon')
      });

      this.steps.push(step);

      if (step.container.hasClass('active')) stepIndexToActivate = step.index;
    });

    this.sortStepsByIndex();
    this.setActiveStep(stepIndexToActivate);
    this.updateButtonVisibility();
  }

  sortStepsByIndex() {
    this.steps.sort((a, b) => a.index - b.index);
  }

  setActiveStep(stepIndex) {
    this.resetAllSteps();
    const targetStep = this.steps[stepIndex];
    if (targetStep) {
      this.activeStep = targetStep;
      this.setNextStep(stepIndex + 1);
      this.updateStepStates();
      this.updateButtonVisibility();
      jQuery(document.body).trigger('update_checkout', [{ update_shipping_method: true }]);
      jQuery(document).trigger('checkoutStepChanged', [this.activeStep.id]);
    }
  }

  changeStepById(stepId) {
    const stepIndex = this.steps.findIndex(step => step.id === stepId);
    if (stepIndex !== -1) {
      this.setActiveStep(stepIndex);
    }
  }

  updateButtonVisibility() {
    const isFirstStep = this.activeStep && this.activeStep.index === 0;
    const isLastStep = this.activeStep && this.activeStep.index === this.steps.length - 1;
    let isPrevLocked = false;

    if (!isFirstStep) {
      const prevStep = this.steps[this.activeStep.index - 1];
      isPrevLocked = prevStep.isLocked;
    }

    // console.log('updateButtonVisibility', {
    //   isFirstStep,
    //   isLastStep,
    //   isPrevLocked,
    //   prevButton: this.prevButton,
    //   nextButton: this.nextButton,
    //   finalButton: this.finalButton
    // });

    this.prevButton.toggle(!isFirstStep);
    this.prevButton.prop('disabled', isFirstStep || isPrevLocked);
    this.nextButton.toggle(!isLastStep);
    if (!this.finalButtonContainer.length) {
      this.finalButton.toggle(isLastStep);
    } else {
      this.finalButtonContainer.toggle(isLastStep);
    }
  }




  resetAllSteps() {
    this.steps.forEach(step => step.reset());
  }

  updateStepStates() {
    this.steps.forEach((step) => {
      if (step.index < this.activeStep.index) step.setComplete();
      else if (step.index == this.activeStep.index) step.setActive();
    });
  }

  setNextStep(index) {
    this.nextStep = this.steps[index] || null;
  }

  next() {
    if (this.nextStep) {
      if (!jQuery('#ship-to-different-address-checkbox').is(':checked')) {
        this.copyBillingToShipping();
      }
      this.setActiveStep(this.nextStep.index);
    }
  }

  copyBillingToShipping() {
    const fieldsToCopy = [
      'first_name', 'last_name', 'address_1', 'address_2', 'city', 'postcode', 'country', 'state', 'company'
    ];

    fieldsToCopy.forEach(field => {
      const billingValue = jQuery(`#billing_${field}`).val();
      jQuery(`#shipping_${field}`).val(billingValue).trigger('change');
    });
  }

  previous() {
    // Find the current active step that is not locked
    const currentStepIndex = this.steps.findIndex(step => step === this.activeStep);
    let targetIndex = currentStepIndex - 1;

    // Loop backward to find the first previous step that is not locked
    while (targetIndex >= 0 && this.steps[targetIndex].isLocked) {
      targetIndex -= 1;
    }

    // If a non-locked step is found, set it as active
    if (targetIndex >= 0) {
      this.setActiveStep(targetIndex);
    }
  }

  isBeyondStep(currentStepId, checkStepId) {
    const currentIndex = this.steps.findIndex(step => step.id === currentStepId);
    const checkIndex = this.steps.findIndex(step => step.id === checkStepId);
    return currentIndex > checkIndex;
  }

  validateCurrentStep() {
    if (this.activeStep && !this.activeStep.isLocked) {
      this.activeStep.validate();
      return this.activeStep.isValid();
    }
  }

}

class CheckoutStep {
  constructor({
    number,
    index,
    id,
    container,
    icon
  }) {
    this.number = number;
    this.index = index;
    this.id = id;
    this.container = container;
    this.icon = icon;
    this.isLocked = container.hasClass('locked');
    this.contentContainer = jQuery(`.mad-checkout-steps__step-content[data-step-id="${id}"]`);
  }

  setActive() {
    if (!this.isLocked) { // Prevent setting a locked step as active
      this.container.addClass('active').removeClass('complete');
      this.contentContainer.addClass('active');
      this.contentContainer.show();
    }
  }

  setComplete() {
    this.container.addClass('complete').removeClass('active');
    this.contentContainer.removeClass('active');
    this.contentContainer.hide();
  }

  reset() {
    this.container.removeClass('active complete');
    this.contentContainer.removeClass('active');
    this.contentContainer.hide();
  }

  validate() {
    const selectors = '.mad-checkout-input, select, input[type=checkbox]';
    const elements = this.contentContainer.find(selectors);
    for (let i = 0; i < elements.length; i++) {
      jQuery(elements[i]).trigger('validate');
    }
  }

  isValid() {
    const inputContainers = this.contentContainer.find('.mad-checkout-input__container');
    for (let i = 0; i < inputContainers.length; i++) {
      if (!jQuery(inputContainers[i]).hasClass('woocommerce-validated')) {
        return false;
      }
    }
    return true;
  }
}

module.exports = CheckoutSteps;